import jwt from '@/helpers/jwtHelper'
import browserHelper from '@/helpers/browserHelper'

export default {
  computed: {
    isFromFunnel() {
      return jwt.payload.tenant.return_url.includes(process.env.VUE_APP_FUNNEL_URL)
    },
    hasPixelParam() {
      const pixel = browserHelper.getUrlParam('pixel')
      return pixel && pixel.toLowerCase() === 'true'
    },
  },
}
